import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { authService } from '../services/auth.service';

// Garde des routes agence (rôle AGENCY, lecture seule des candidatures).
const AgencyRoute: React.FC = () => {
  if (!authService.isAuthenticated()) {
    return <Navigate to="/signin" replace />;
  }
  if (!authService.isAgency()) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
};

export default AgencyRoute;
